export default "__VITE_ASSET__BQihgZ4Z__"